import React, { Component } from 'react';
import { connect } from 'react-redux';
import WithinViewport from 'react-within-viewport';
import Card from './Card/Card';
import ExpandableContent from './ExpandableContent';
import { getRecommendations } from '../actions/recommendations';
import { trackEvent } from '../actions/tracking';
import Publication from './Publication';
import PublicationDetails from './PublicationDetails';
import FullTextButton from './FullTextButton';
import SaveToLibrary from './SaveToLibrary';

class PublicationSuggestions extends Component {
  state = {}

  componentWillMount() {
    const {
      doc: { id },
      recommendations,
    } = this.props;

    if (!recommendations) {
      this.props.getRecommendations(id);
    }
  }

  componentWillUpdate(props, state) {
    const {
      track,
      inViewport,
      doc,
      profile_uuid // eslint-disable-line camelcase
    } = props;
    const { focusTracked } = state;
    if (inViewport && track && !focusTracked) {
      // eslint-disable-next-line react/no-unused-state, react/no-will-update-set-state
      this.setState({ focusTracked: true }, () => {
        props.trackEvent({
          ...track,
          profile_uuid,
          action: 'InFocus',
          value: { documentId: doc.id },
          label: doc.title
        });
      });
    }
  }

  render() {
    const {
      track,
      recommendations,
    } = this.props;

    const shouldRender =
      recommendations &&
      !recommendations.error &&
      recommendations.length;

    if (!shouldRender) return null;

    const documents = recommendations.map(doc => (
      <Publication
        className="publication-list-item"
        key={doc.id}
      >
        <PublicationDetails
          doc={doc}
          track={track}
          isSuggested
        />
        <div className="button-group">
          <SaveToLibrary
            doc={doc}
            buttonStyle="basic"
            track={track}
            isSuggested
            tertiary
          />
          <FullTextButton
            doc={doc}
            track={track}
            isSuggested
          >
            Get full text at journal
          </FullTextButton>
        </div>
      </Publication>
    ));

    return (
      <Card
        title="Suggestions based on this article"
        className="publication-list"
      >
        <ExpandableContent
          initialItems={1}
          items={documents}
          track={track}
        />
      </Card>
    );
  }
}

const mapStateToProps = (state, props) => ({
  recommendations: state.recommendations[props.doc.id],
  isAuthenticated: state.session.isAuthenticated,
  profile_uuid: state.session.user,
});

const mapDispatchToProps = {
  trackEvent,
  getRecommendations,
};

const SuggestionsInViewport = WithinViewport()(PublicationSuggestions);
export default connect(mapStateToProps, mapDispatchToProps)(SuggestionsInViewport);



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationSuggestions.js